import { BiDownArrow, BiUpArrow } from "react-icons/bi";
import { GrAdd } from "react-icons/gr";
import { useContext, useState } from "react";
import SectionModal from "./SectionModal";
import LoadingCircle from "../../utility/LoadingCircle";
import UserContext from "../../User/UserContext";
import PermissionGuard from "../../User/PermissionGuard";
import PermissionsMap from "../../User/PermissionsMap";

const SectionList = ({ sections, setSections, sectionWordBank, template_id, isLoading, isDrafting, updateSectionInDB }) => {
	const { api, token } = useContext(UserContext);
	const [showSectionModal, setShowSectionModal] = useState(false);

	const moveSectionUp = async (indexToSwitch) => {
		let destination = indexToSwitch - 1;
		if (destination < 0) {
			return;
		}
		let arrayCopy = [...sections];
		let swappedPosition = arrayCopy[destination].position;
		await updateSectionInDB(arrayCopy[destination], arrayCopy[indexToSwitch].position);
		await updateSectionInDB(arrayCopy[indexToSwitch], arrayCopy[destination].position);
		arrayCopy[destination].position = arrayCopy[indexToSwitch].position;
		arrayCopy[indexToSwitch].position = swappedPosition;

		arrayCopy = arrayCopy.sort((a, b) => a.position - b.position);
		setSections(arrayCopy);
	};

	const moveSectionDown = async (indexToSwitch) => {
		let destination = indexToSwitch + 1;
		if (destination >= sections.length) {
			return;
		}
		let arrayCopy = [...sections];
		let swappedPosition = arrayCopy[destination].position;
		await updateSectionInDB(arrayCopy[destination], arrayCopy[indexToSwitch].position);
		await updateSectionInDB(arrayCopy[indexToSwitch], arrayCopy[destination].position);
		arrayCopy[destination].position = arrayCopy[indexToSwitch].position;
		arrayCopy[indexToSwitch].position = swappedPosition;

		arrayCopy = arrayCopy.sort((a, b) => a.position - b.position);
		setSections(arrayCopy);
	};

	return (
		<div className="mb-4  md:sticky md:top-0 z-50">
			{showSectionModal ? (
				<SectionModal
					isCreatingSection={true}
					setShowSectionModal={setShowSectionModal}
					sectionWordBank={sectionWordBank}
					template_id={template_id}
					sections={sections}
					setSections={setSections}
				/>
			) : null}

			<div className="flex justify-between items-center text-2xl">
				<p>Sections</p>
				{sectionWordBank && sectionWordBank.length > 0 && isDrafting ? (
					<PermissionGuard permission={PermissionsMap.TEMPLATES_CREATE}>
						<GrAdd
							className="text-3xl cursor-pointer"
							onClick={() => {
								setShowSectionModal(true);
							}}
						/>
					</PermissionGuard>
				) : null}
			</div>
			<div className="md:overflow-y-scroll md:h-[60vh]">
				{sections && sections.length > 0 ? (
					sections.map((vals, index) => {
						return (
							<div key={vals.id} className="border-l-4 p-1 pl-2 flex justify-between items-center">
								<a className="text-blue-600 underline" href={"#" + vals.name.replaceAll(" ", "-")}>
									{vals.name}
								</a>
								<div className="flex text-2xl">
									{isDrafting ? (
										<PermissionGuard permission={PermissionsMap.TEMPLATES_UPDATE}>
											<>
												<BiDownArrow className="cursor-pointer select-none" onClick={() => moveSectionDown(parseInt(index))} />
												<BiUpArrow className="cursor-pointer select-none" onClick={() => moveSectionUp(parseInt(index))} />
											</>
										</PermissionGuard>
									) : null}
								</div>
							</div>
						);
					})
				) : isLoading ? (
					<div className="flex flex-col items-center justify-center w-full my-2">
						<LoadingCircle />
						<p>Loading List</p>
					</div>
				) : (
					<p>There are no sections</p>
				)}
			</div>
		</div>
	);
};

export default SectionList;
